import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function GraphIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M4 17H6V21H4V17ZM9 21H11V13H9V21ZM14 21H16V15H14V21ZM19 21H21V10H19V21ZM20 2C18.8954 2 18 2.89539 18 4C18 4.22583 18.0457 4.43921 18.1147 4.6416L14.7812 8.46875L9.8252 5.67285L3.28809 12.2978L4.71192 13.7022L10.1748 8.16699L15.2188 11.0117L19.6179 5.96143C19.7418 5.98548 19.8691 6 20 6C21.1046 6 22 5.10449 22 4C22 2.89539 21.1046 2 20 2H20Z",
    fill: "currentColor"
  }));
}